import React from 'react';
import { XIcon as HeroXIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type XIconProps = Omit<IconProps, 'children'>;

export const XIcon: React.FC<XIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroXIcon />
        </Icon>
    );
};
